module.exports = __webpack_public_path__ + "media/application/images/icons/close-31bd1b4a31addaac7b1d22db331a427f.png";